
const INITIAL_STATE = {
    action:false,
    simple:false,
    error:false,
    message:'',
    callback: () => null,
    callbackText:''
}

export default (state = INITIAL_STATE, action) =>{
    switch (action.type) {
        case 'SETSYSTEM':{
            return {
                ...state,
                ...action.payload
            };
        }
        case 'showSimple':{
            
            return {
                ...state,
                simple:true,
                message:action.payload.message
                
            };
        }
        case 'showAction':{
            
            return {
                ...state,
                action:true,
                message:action.payload.message,
                callback:action.payload.callback,
                callbackText:action.payload.callbackText
            };
        }
        case 'showError':{
            return {
                ...state,
                error:true,
                message:action.payload.message,
            };
        }
        case 'close':{
            return {
                ...state,
                simple:false,
                action:false,
                error:false,
                message:''
            };
        }
        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/snackbarReducer.js